var map = {
	"./chart-widget-configuration": "app/widgets/chart-widget-configuration",
	"./comparison-widget-configuration": "app/widgets/comparison-widget-configuration",
	"./count-widget-configuration": "app/widgets/count-widget-configuration",
	"./entity-finder-configuration": "app/widgets/entity-finder-configuration",
	"./entity-finder-widget-configuration": "app/widgets/entity-finder-widget-configuration",
	"./gauge-widget-configuration": 5005,
	"./list-widget-configuration": "app/widgets/list-widget-configuration",
	"./text-widget-configuration": "app/widgets/text-widget-configuration"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2195;